module.exports = __webpack_public_path__ + "img/NO937894082.fd8079fa.png";